import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { initialsFor } from '@/features/profile/format';
import { useLocaleOptional } from '@/i18n/locale';

export interface PaletteAvatarProps {
  name: string;
  avatarUrl: string | null;
  palette: [string, string];
  className?: string;
  /** Accessible name for the image — defaults to `common.avatarOf`; pass `''` for decorative. */
  alt?: string;
}

/**
 * The one gradient-initials avatar (today `PersonAvatar` + three inline
 * copies). The fallback is a flat colour from `palette[0]` with the initials —
 * deliberately not a gradient (craft rule: no gradients) — in `text-on-image`.
 */
export function PaletteAvatar({
  name,
  avatarUrl,
  palette,
  className = 'h-11 w-11',
  alt,
}: PaletteAvatarProps) {
  const { t } = useLocaleOptional();
  const resolvedAlt = alt ?? t('common.avatarOf', { name });
  const [fallback] = palette;
  return (
    <Avatar className={className}>
      {avatarUrl ? <AvatarImage src={avatarUrl} alt={resolvedAlt} /> : null}
      <AvatarFallback
        className="text-subhead text-on-image"
        style={{ backgroundColor: fallback }}
      >
        {initialsFor(name)}
      </AvatarFallback>
    </Avatar>
  );
}
